import { ICarouselProducts, IPrismicCarouselProducts } from './types';

export const mapCarouselProducts = ({
  prismicContent,
  position,
}): ICarouselProducts => {
  const { items, primary }: IPrismicCarouselProducts = prismicContent;

  const {
    text_link: textLink,
    collection: { handle },
    tracking_id: trackingId,
    card_title: cardTitle,
    card_description: cardDescription,
    card_link_label: cardLinkLabel,
    card_link: cardLink,
    card_background_color: cardBackgroundColor,
    card_illustration: cardIllustration,
    card_tracking_id: cardTrackingId,
  } = primary;

  return {
    ...primary,
    textLink,
    handle,
    items,
    trackingId,
    cardTitle,
    cardDescription,
    cardLinkLabel,
    cardLink,
    cardBackgroundColor,
    cardIllustration,
    cardTrackingId,
    position,
  };
};
